<script>
import DropdownMenu from 'v-dropdown-menu';
import $ from 'jquery';

export default {
  extends: DropdownMenu,
  setup(props, ctx) {
    return {
      ...DropdownMenu.setup(props, ctx),
      // local bindings
    };
  },
  data() {
    return {
      overlayAk: true,
    };
  },
  props: {
    closeOnClickOutsideAk: {
      type: Boolean,
      required: false,
      default: false,
    },
    classInside: {
      type: Array,
      required: false,
      default: () => [],
    },
    blockScroll: {
      type: Boolean,
      required: false,
      default: true,
    },
    overlay: {
      type: Boolean,
      required: false,
      default: false,
    },
    fitViewport: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.overlayAk = this.$isMobile();
      if (this.closeOnClickOutsideAk) {
        this.registerCloseDropdownOnClickOutsideAk();
      }
    });
  },
  updated() {
    if (this.$isMobile()) {
      $(this.rootRef).addClass('dropdown__mobile');
    }
  },
  beforeUnmount() {
    this.destroyCloseDropdownOnClickOutsideAk();
    this.stopFitViewport();
  },
  watch: {
    'menu.isOpen': function (newValue) {
      if (newValue) {
        if (this.overlayAk || this.overlay) {
          $('<div>', {
            id: 'dropdown-overlay',
            class: 'v-dropdown-menu__overlay v-dropdown-menu__overlay_ak',
          }).appendTo($(this.rootRef));
          let that = this;
          $('.v-dropdown-menu__overlay_ak').on('click', this.hide);
        }
        if (this.blockScroll) {
          $('body').addClass('overflow-hidden');
        }
        if (this.fitViewport && !this.$isMobile()) {
          this.$nextTick(this.startFitViewport);
        }
      } else {
        this.stopFitViewport();
        $('.v-dropdown-menu__overlay').remove();
        $('.v-dropdown-menu__overlay_ak').remove();
        if (this.blockScroll) {
          $('body').removeClass('overflow-hidden');
        }
      }
    },
  },
  methods: {
    startFitViewport() {
      const container = this.rootRef?.querySelector('.v-dropdown-menu__container');
      if (!container) return;
      this.fitContainer = container;
      this.fitObserver = new window.ResizeObserver(this.moveContainerInViewport);
      this.fitObserver.observe(container);
    },
    moveContainerInViewport() {
      const container = this.fitContainer;
      const margin = 8;
      container.style.top = '';
      const rootTop = this.rootRef.getBoundingClientRect().top;
      const overflow = rootTop + container.offsetTop + container.offsetHeight + margin - window.innerHeight;
      if (overflow > 0) {
        container.style.top = Math.max(container.offsetTop - overflow, margin - rootTop) + 'px';
      }
    },
    stopFitViewport() {
      if (this.fitObserver) this.fitObserver.disconnect();
      if (this.fitContainer) this.fitContainer.style.top = '';
      this.fitObserver = null;
      this.fitContainer = null;
    },
    registerCloseDropdownOnClickOutsideAk() {
      window.addEventListener('click', this.closeDropdownOnClickOutsideAk);
    },
    closeDropdownOnClickOutsideAk(e) {
      if (this.menu.isOpen) {
        let isInside = $(this.rootRef).html().includes($(e.target).html());
        let hasClassInside = false;
        for (let c of this.classInside) {
          hasClassInside = $(e.target).hasClass(c);
          if (hasClassInside) break;
        }
        if ((!isInside && !hasClassInside) || (isInside && this.classInside.length === 0)) {
          this.menu.isOpen = false;
        }
      }
    },
    destroyCloseDropdownOnClickOutsideAk() {
      if (this.closeOnClickOutside) {
        window.removeEventListener('click', this.closeDropdownOnClickOutsideAk);
      }
    },
  },
};
</script>
